import { TextDisplayCell } from "../../../common/components/DataGrid";
import {
  generateModbusIPCell,
  generateModbusMapIDCell,
  generateModbusPortCell,
  generateModbusRegisterCell,
  generateModbusRegisterPLCCell,
  generateModbusRegisterRTUCell,
  generateModbusSlaveIdCell,
  generateSyncDirectionCell,
} from "../../helpers/CellGenerators";

export const ModbusRegisterCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateModbusRegisterCell(row, lookupValues)} />
  );
};

export const ModbusIPCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateModbusIPCell(row, lookupValues)} />;
};

export const ModbusPortCell = ({ row, lookupValues }) => {
  return <TextDisplayCell value={generateModbusPortCell(row, lookupValues)} />;
};

export const ModbusSlaveIdCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateModbusSlaveIdCell(row, lookupValues)} />
  );
};

// Named for the property rather than the protocol, but Modbus-only all the same.
export const SyncDirectionCell = ({ row, lookupValues }) => {
  return (
    <TextDisplayCell value={generateSyncDirectionCell(row, lookupValues)} />
  );
};

// The map/PLC/RTU addresses below are computed from TagIdentifier for any tag, so unlike the cells
// above they are not restricted to Modbus source types and take no lookupValues.
export const ModbusMapIDCell = ({ row }) => {
  return <TextDisplayCell value={generateModbusMapIDCell(row)} />;
};

export const ModbusRegisterPLCCell = ({ row }) => {
  return <TextDisplayCell value={generateModbusRegisterPLCCell(row)} />;
};

export const ModbusRegisterRTUCell = ({ row }) => {
  return <TextDisplayCell value={generateModbusRegisterRTUCell(row)} />;
};
